import { render, staticRenderFns } from "./LoaderPlaceholder.vue?vue&type=template&id=711351a6&"
import script from "./LoaderPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./LoaderPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./LoaderPlaceholder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports